import { Component } from '@angular/core';
import { SalesSummaryCardComponent } from 'gung-dashboard';

@Component({
    selector: 'otto-olsen-customers-summary-card',
    templateUrl: './otto-olsen-customers-summary-card.component.html',
    styleUrls: ['./otto-olsen-customers-summary-card.component.scss'],
    standalone: false
})
export class OttoOlsenCustomersSummaryCardComponent extends SalesSummaryCardComponent {}
